import { makeAutoObservable, runInAction } from 'mobx';

import RootStore from '../Root.store';
import { WebMonitor } from '../../models/AdminWeb';
import axios, { AxiosError } from 'axios';

class WebMonitorStore {
    public fetching = false;
    public webMonitors?: WebMonitor[] = undefined;

    constructor(private rootStore: RootStore) {
        makeAutoObservable(this);
    }

    public async fetchWebMonitor() {
        try {
            this.fetching = true;

            const response = await axios.get<WebMonitor[]>('/v1/monitor/web', {
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem('MM_APPLICATION')
                }
            });
            const webMonitors = response.data.sort((a, b) =>
                a.name < b.name ? -1 : a.name > b.name ? 1 : 0
            );

            runInAction(() => (this.webMonitors = webMonitors));
        } catch (error) {
            console.error('fetchWebMonitors', (error as AxiosError).response?.data);

            throw error;
        } finally {
            this.fetching = false;
        }
    }
}

export default WebMonitorStore;
